export default {
  "path": "/demo/detail-part-title",
  "meta": {
    "name": "demo-详情标题",
    "title": "PartTitle 详情标题",
    "isComponentDoc": true,
    "category": "Detail"
  }
};